import { FETCH_DELETED_VM_LIST } from "../../constants/action.constants";

const initialState = {
  list: [],
  others: {},
  selectList: [],
};

const deletedVMListReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_DELETED_VM_LIST:
      return { list: action.payload, others: action.others };
    default:
      return state;
  }
};

export default deletedVMListReducer;
